module.exports = __webpack_public_path__ + "img/pakiet-pszczelego-bohatera.994cf5f8.jpeg";